import React, { useEffect, useMemo } from 'react'
import { RouteProps, useNavigate } from 'react-router-dom'

import DeclarationTemplate, { DeclarationTemplateProps } from '../../templates/Declaration'
import { useHeader } from '../../relay/Header/useHeader'
import { useFooter } from '../../relay/Footer/useFooter'
import { useDeclarationForm } from '../../relay/Declaration/useDeclarationForm'
import { routesPath } from '../../router'

const DeclarationPage: React.FC<RouteProps> = () => {
  const header = useHeader()
  const footer = useFooter()
  const { hasDeclaration, home, declarationForm, hasToOptin } = useDeclarationForm()
  const navigate = useNavigate()

  useEffect(() => {
    if (hasToOptin) {
      navigate(routesPath.home)
    }
  }, [hasToOptin, navigate])

  const templateProps: DeclarationTemplateProps = useMemo(
    () => ({
      layout: {
        header,
        footer,
      },
      hasDeclaration,
      hasToOptin,
      home,
      declarationForm,
    }),
    [hasToOptin, declarationForm, footer, hasDeclaration, header, home]
  )

  return <DeclarationTemplate {...templateProps} />
}

export default DeclarationPage
